import MessagesPage from "@/components/MessagesPage";

export default function VendorMessages() {
  return (
    <MessagesPage
      accent="emerald"
      eyebrow="Vendor · Messages"
      title="Inbox"
      audienceHint="Direct, threaded conversations between you and the Nodera operations team."
    />
  );
}
